module.exports = __webpack_public_path__ + "static/media/20-oct23dec23.2ea8ad40.pdf";